import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Auth } from '@aws-amplify/auth';

interface useAuthProps {
  userId?: string;
  setUserId: (userId?: string) => void;
}

export const useAuth = ({ userId, setUserId }: useAuthProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const authenticate = async () => {
      if (userId) {
        navigate(`/${userId}`);
      } else {
        try {
          const authenticatedUser = await Auth.currentAuthenticatedUser();
          if (window.Intercom) {
            window.Intercom('boot', {
              api_base: 'https://api-iam.intercom.io',
              app_id: process.env.REACT_APP_INTERCOM_APP_ID,
              user_active_company_id: -1,
              user_id: authenticatedUser.attributes.sub,
              name: authenticatedUser.attributes.name,
              email: authenticatedUser.attributes.email,
              phone: authenticatedUser.attributes.phone_number,
              page_title: 'calo-affiliates-portal'
            });
          }
          setUserId(authenticatedUser.attributes.sub);
        } catch {
          if (location.pathname === '/uk') {
            navigate(location.pathname);
          } else {
            navigate('/');
          }
        }
      }
    };
    authenticate();
  }, [navigate, userId, setUserId, location.pathname]);
};
